<template>
  <div class="content-container">
    <div class="content">
      <z-icon :name="iconConfig.type" class="result-icon" :style="{'color': iconConfig.color}"/>
      <h3 class="result-title">{{statusTip.title}}</h3>
      <p class="result-desc">{{statusTip.desc}}</p>
      <z-button @click="handleResubmit" v-show="showBtn" type="primary">重新提交</z-button>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon, Button } from '@zz-common/zz-ui';
import { queryParams } from '../../lib/utils'

const query = queryParams()
export default {
  name: 'AuditStatus',
  data() {
    return {
      auditStatus: query.auditStatus || this.$route.query.auditStatus,
      infoId: query.infoId || this.$route.query.infoId,
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      statusDesc: query.statusDesc || this.$route.query.statusDesc,
      statusList: [
        {
          title: '审核通过',
          desc: '恭喜您提交的信息已审核通过'
        },
        {
          title: '审核未通过',
          desc: '很抱歉，您提交的信息未能通过审核\n未通过原因：缺少信息'
        },
        {
          title: '审核中',
          desc: '您提交的信息正在处理，我们会在24~72小时内完成审核，请您耐心等待，谢谢！'
        }
      ]
    }
  },
  computed: {
    iconConfig() {
      let iconInfo = null;
      switch (this.auditStatus) {
        case '1': iconInfo = { type: 'passed', color: '#ff5757' }; break; // 通过
        case '2': iconInfo = { type: 'close', color: '#ccc' }; break; //拒绝
        case '3': iconInfo = { type: 'clock-o', color: '#ccc' }; break; //待审核
        default: break;
      }
      return iconInfo;
    },
    statusTip() {
      let res = this.statusList[this.auditStatus - 1]
      if (this.auditStatus === '2' && this.statusDesc) { // 拒绝
        res = { ...res, desc: `很抱歉，您提交的信息未能通过审核\n未通过原因：${this.statusDesc}` }
      }
      return res
    },
    showBtn() {
      return this.auditStatus == 2
    }
  },
  methods: {
    handleResubmit() { // 重新提交
      this.$router.replace({
        path: '/productqua/submit',
        query: {
          sourceCode: this.sourceCode,
          infoId: this.infoId
        }
      })
    }
  },
  components: {
    zIcon: Icon,
    zButton: Button
  },
  created() {
    native.setTitle({
      title: '商品资质核验'
    })
  }
}

</script>
<style lang="less">
  @import 'auditStatus.less';
</style>